import { render, staticRenderFns } from "./NoteTemplate.vue?vue&type=template&id=7188ba68&scoped=true"
import script from "./NoteTemplate.vue?vue&type=script&lang=js"
export * from "./NoteTemplate.vue?vue&type=script&lang=js"
import style0 from "./NoteTemplate.vue?vue&type=style&index=0&id=7188ba68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7188ba68",
  null
  
)

export default component.exports